/* eslint-disable */
import createIcon from '../createIcon';

const IconCloseCircleOutlined = createIcon({
  name: 'icon-close-circle-outlined',
  content: '<path d="M514.230243 944.348475a446.048538 446.048538 0 0 1-318.606099-760.19415A446.048538 446.048538 0 0 1 512.955818 52.2514a446.048538 446.048538 0 0 1 446.048538 446.048538 446.048538 446.048538 0 0 1-446.048538 446.048537z m0-828.375855a382.327318 382.327318 0 0 0 0 764.654636 382.327318 382.327318 0 0 0 382.327318-382.327318 382.327318 382.327318 0 0 0-382.327318-382.327318z"/><path d="M669.072806 689.909645L307.391164 330.71313l44.92346-45.242066 361.681642 359.323958z"/><path d="M713.486497 330.075918L354.289981 691.757561l-45.242066-44.92346 359.323958-361.681643z"/>',
  width: 1024,
  height: 1024
}, 'Icon');
export default IconCloseCircleOutlined;
